import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

function useForceReloadOnNavigate() {
  const location = useLocation();
  const initialLoad = useRef(true);
  const lastPath = useRef(location.pathname);  // 遷移前のパスを保持する

  // 定義された有効なURLパス
  const validPaths = ['/', '/about/', '/service/', '/fix/', '/recruit/', '/company/', '/contact/', '/posts/', '/works/', '/voice/', '/post/'];

  function extractBasePath(pathname) {
    // パスを「/」で分割し、必要な部分だけを抽出して再組み立て
    const parts = pathname.split('/');
    if (!parts[1]) {
      return `/`;  // 最初の二つのセグメントを取得
    } else {
      return `/${parts[1]}/`;  // 最初の二つのセグメントを取得
    }
  }

  useEffect(() => {

    const path = extractBasePath(location.pathname);
    const last = extractBasePath(lastPath.current);

    const currentPathIsValid = validPaths.includes(path);
    const lastPathIsValid = validPaths.includes(last);
    lastPath.current = location.pathname;  // 現在のパスを遷移前のパスとして更新
    // console.log(lastPath.current, path);
    // console.log(lastPathIsValid, currentPathIsValid);

    // 初回ロードを無視し、以下の条件でリロードを実行
    // 1. 遷移前のパスが有効でなく、現在のパスが有効である場合
    // 2. 遷移前のパスが有効で、現在のパスが有効でない場合
    // 3. 遷移前のパスが有効でなく、現在のパスも有効でない場合

    if (!initialLoad.current && ((!lastPathIsValid && currentPathIsValid) || (lastPathIsValid && !currentPathIsValid) || (!lastPathIsValid && !currentPathIsValid))) {
      window.location.reload();
    } else {
      lastPath.current = location.pathname;  // 現在のパスを遷移前のパスとして更新
      initialLoad.current = false;  // 初回ロードフラグをオフにする
    }
  }, [location.pathname]);
}

export default useForceReloadOnNavigate